import Uppy from "@uppy/core";
import Tus from "@uppy/tus";
import { useState } from "react";
import { useStore } from "../../../stores/use_global_state";
import Image from "next/image";
import { HandySvg } from "handy-svg";
import styles from "./ediror.module.scss";

const UploadPhoto = ({ sportCardsState, setSteps }) => {
  const { state } = useStore();
  let token = state?.userInfo?.token ? state.userInfo.token : false;
  const [photos, setPhotos] = useState([]);
  const [mainPhoto, setMainPhoto] = useState(null);
  const [isLoading, setIsLoading] = useState();

  const send = async (e) => {
    const oldPhotos = [...photos];
    console.clear();
    setIsLoading(true);
    const files = Object.values(e.target.files);

    const uppy = new Uppy().use(Tus, {
      endpoint: `${process.env.NEXT_PUBLIC_API_URL}/v1/sportcards/uploads`,
      headers: {
        authorization: `Bearer ${token}`
      },
      chunkSize: 1024 * 1024 * 1
    });

    // Функция для обновления списка фотографий
    const updatePhotosList = () => {
      const newPhotosList = [...oldPhotos, ...uppy.getFiles()].filter(
        (item, index, self) => index === self.findIndex((t) => t.id === item.id)
      );
      setPhotos(newPhotosList);
    };

    // Добавляем файлы в Uppy
    files.forEach((fileData) => {
      const { name, type } = fileData;
      const metaData = { name, mimeType: type, collection: "sportcards/photos" };

      uppy.addFile({ name, type, data: fileData, meta: metaData, preview: URL.createObjectURL(fileData) });
    });

    // Подписываемся на события до начала загрузки
    uppy
      .on('progress', updatePhotosList)
      .on('complete', () => {
        updatePhotosList();
        setIsLoading(false);
      })
      .on('error', (error) => {
        console.error('Uppy error:', error);
        setIsLoading(false);
      });

    // Начинаем загрузку
    try {
      await uppy.upload();
    } catch (error) {
      console.error('Upload failed:', error);
      setIsLoading(false);
    }

    // Очистка при размонтировании компонента
    return () => {
      uppy.close();
    };
  };

  const Next = async () => {
    await updatePersonData(sportCardsState.person.id, { main_person_image_url: mainPhoto?.uploadURL, person_image_urls: photos.map(photo => photo.uploadURL) }, token);
    setSteps(prev => prev.map(step => step.name === "Template" ? { ...step, active: true } : { ...step, active: false }));
  }

  return (
    <>
      <p className={styles.description}>
        Upload 15 - 20 photos to get the best result and select 1 photo as the main one.
        {/* <span>Follow these requirements</span> */}
      </p>
      <div className={styles.uploadPhotoWrapper}>
        <label className={`${styles.uploadPhotoItem} ${styles.uploadPhotoItemImput}`}>
          <input onChange={send} type="file" accept="image/*" multiple />
          <Image src={"/sport_cards/download.png"} alt="pose" width="24" height="24" quality={99} unoptimized />
          <p>Add photo</p>
        </label>
        {photos?.map(photo => (
          <button onClick={() => setMainPhoto(photo)} key={photo.id} className={`${styles.uploadPhotoItem} ${photo.id === mainPhoto?.id ? styles.uploadPhotoItemActive : ""}`}>
            <button className={styles.uploadPhotoItemDelete} onClick={(e) => { e.stopPropagation(); photo.id === mainPhoto?.id && setMainPhoto(null); setPhotos((prev) => prev.filter(p => p.id !== photo.id)) }} aria-label="delete photo">
              <HandySvg src={"/survey/close.svg"} width={12} height={12} fill={"transparent"} />
            </button>
            <Image className={styles.uploadPhotoItemImg} src={photo.uploadURL || photo.preview} alt="pose" width="150" height="150" quality={99} unoptimized />
            {photo.progress?.percentage < 100 && <div className={styles.uploadPhotoItemLoading}>{photo.progress.percentage}</div>}
          </button>
        ))}
      </div>
      <button onClick={Next} disabled={!mainPhoto || photos.length < 5} className={styles.nextBtn}>Next <HandySvg src={"/illustration_service/next.svg"} width={24} height={24} fill={"transparent"} /></button>
    </>
  )
}

export default UploadPhoto